import { useEffect, useState } from "react";
import api from "@/lib/api";
import { wibToday } from "@/lib/bizdate";

export const COMP_LABELS = {
  chat_response: "Chat Response (20)",
  order_management: "Order Management (20)",
  complaints_cancellation: "Complaints & Cancellation (15)",
  stock_product: "Stock & Product (15)",
  ads_sales: "Ads & Sales (15)",
  admin_activity: "Admin Activity (10)",
  report_completeness: "Report Completeness (5)",
};
export const COMP_MAX = { chat_response: 20, order_management: 20, complaints_cancellation: 15, stock_product: 15, ads_sales: 15, admin_activity: 10, report_completeness: 5 };
export const today = () => wibToday();
export const statusColor = (s) => ({ "Sangat Baik": "text-emerald-600", "Baik": "text-sky-600", "Perlu Perhatian": "text-amber-600", "Perlu Tindakan": "text-rose-600" }[s] || "text-slate-600");
export const flowColor = (s) => ({ DRAFT: "bg-slate-200 text-slate-700", SUBMITTED: "bg-sky-100 text-sky-700", REVIEWED: "bg-amber-100 text-amber-700", APPROVED: "bg-emerald-100 text-emerald-700" }[s] || "bg-slate-200");

export function useRefs() {
  const [refs, setRefs] = useState({ stores: [], marketplaces: [], components: {}, topics: [], chat_statuses: [], store_statuses: [] });
  useEffect(() => { api.get("/oms/refs").then((r) => setRefs(r.data)).catch(() => {}); }, []);
  return refs;
}

export const chatStatusColor = (s) => ({ Terbuka: "bg-sky-100 text-sky-700", Diproses: "bg-amber-100 text-amber-700", Selesai: "bg-emerald-100 text-emerald-700" }[s] || "bg-slate-200 text-slate-700");
export const storeStatusColor = (s) => ({ Normal: "text-emerald-600", "Perlu Perhatian": "text-amber-600", Bermasalah: "text-rose-600", "Dibatasi Marketplace": "text-rose-700", Libur: "text-slate-500", Nonaktif: "text-slate-400" }[s] || "text-slate-600");
export const naVal = (v) => (v === null || v === undefined ? "Belum tersedia" : v);
export const rupiah = (n) => "Rp" + Math.round(n || 0).toLocaleString("id-ID");
